export default __webpack_public_path__ + "static/media/HAT1204_tn.e3401960.jpg";